import { MutationTree } from 'vuex'
import { AccountState } from './AccountState'
import { AccountDto } from '@/Application/Authentication'

export const mutations: MutationTree<AccountState> = {
  setAccountData (state: AccountState, payload: AccountDto) {
    state.username = payload.username
    state.accountId = payload.accountId
  },
  removeUser (state: AccountState) {
    state.username = ''
    state.accountId = ''
  }
}
